module.exports = __webpack_public_path__ + "static/img/13.1c0a705.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhwhyx/13.jpg
// module id = 0ZJV
// module chunks = 1